import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components

import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Switch from '../../../shared/elements/switch'
// import Text from '../../../shared/elements/text'
import DropDown from '../../../shared/elements/dropDown'

// Actions
import { getProcessManagementInformation, saveProcessManagementInformation } from '../../../actions/settings'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'
import LabelWrapper from '../../../shared/elements/labelWrapper'

class ProcessManagement extends Component {
  constructor (props) {
    super(props)

    this.state = {
      UseAutoOrderMove: false,
      UseLoosePartOrderSplit: false,
      BufferTimeBeforeProduction: 0,
      BufferTimeDelivery: 0
    }

    this.saveSettings = this.saveSettings.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.props.getProcessManagementInformation(this.props.auth.user.ShopId).then(res => {
      this.setState({
        UseAutoOrderMove: res.data.UseAutoOrderMove,
        UseLoosePartOrderSplit: res.data.UseLoosePartOrderSplit,
        BufferTimeBeforeProduction: res.data.BufferTimeBeforeProduction,
        BufferTimeDelivery: res.data.BufferTimeDelivery
      })
    }, err => {
      console.log(err)
    })
  }

  saveSettings () {
    const {UseAutoOrderMove, UseLoosePartOrderSplit, BufferTimeBeforeProduction, BufferTimeDelivery} = this.state

    const data = {
      ShopId: this.props.auth.user.ShopId,
      UseAutoOrderMove,
      UseLoosePartOrderSplit,
      BufferTimeBeforeProduction,
      BufferTimeDelivery
    }

    this.props.saveProcessManagementInformation(data).then(res => {
      this.setState({
        UseAutoOrderMove: res.data.UseAutoOrderMove,
        UseLoosePartOrderSplit: res.data.UseLoosePartOrderSplit,
        BufferTimeBeforeProduction: res.data.BufferTimeBeforeProduction,
        BufferTimeDelivery: res.data.BufferTimeDelivery
      })

      // Toastr
      if (res.data.MessageKey === 0) {
        // window.toastr.success(translation('15258'), translation('13424'))
      } else {
        window.toastr.error(translation(res.data.MessageKey), translation('216'))
      }
    }).catch(() => {
      // Toastr
      window.toastr.error(translation('910'), translation('216'))
    })
  }

  onChange (e) {
    let value = e.target.value
    let type = e.target.type
    if (type === 'checkbox') {
      value = e.target.checked
    }

    this.setState({
      [e.target.name]: value
    }, () => {
      if (type !== 'text') {
        this.saveSettings()
      }
    })
  }

  onBlur (e) {
    this.saveSettings()
  }

  render () {
    let bufferTimeOptions = this.getBufferTimeOptions()
    return (
      <div className='forsi__page'>
        <Row>
          <Col>
            <Panel title={translation('15252')} helpText={translation('15253')}>
              <Switch name='UseLoosePartOrderSplit' onChange={this.onChange} checked={this.state.UseLoosePartOrderSplit} labelText={translation('15256')} helpText={translation('15257')} />
              <Switch name='UseAutoOrderMove' onChange={this.onChange} checked={this.state.UseAutoOrderMove} labelText={translation('15254')} helpText={translation('15255')} />
            </Panel>
          </Col>
          <Col>
            <Panel title={translation('17894')} helpText={translation('17896')}>
              <LabelWrapper labelText={17895}>
                <DropDown name='BufferTimeBeforeProduction' onChange={this.onChange} value={this.state.BufferTimeBeforeProduction}>
                  {Object.keys(bufferTimeOptions).map(key => {
                    return <option value={Number(key)} key={'BufferTimeBeforeProduction_' + key}>{bufferTimeOptions[key]}</option>
                  })}
                </DropDown>
              </LabelWrapper>

              {hasSubscriptionPermission(this.props.auth, 20) && <LabelWrapper labelText={18091}>
                <DropDown name='BufferTimeDelivery' onChange={this.onChange} value={this.state.BufferTimeDelivery}>
                  {Object.keys(bufferTimeOptions).map(key => {
                    return <option value={Number(key)} key={'BufferTimeDelivery_' + key}>{bufferTimeOptions[key]}</option>
                  })}
                </DropDown>
              </LabelWrapper>}
            </Panel>
          </Col>
        </Row>
      </div>
    )
  }

  getBufferTimeOptions () {
    return {
      0: '00:00 ' + translation(18296),
      15: '00:15 ' + translation(18296),
      30: '00:30 ' + translation(18296),
      45: '00:45 ' + translation(18296),
      60: '01:00 ' + translation(18296),
      75: '01:15 ' + translation(18296),
      90: '01:30 ' + translation(18296),
      105: '01:45 ' + translation(18296),
      120: '02:00 ' + translation(18296),
      135: '02:15 ' + translation(18296),
      150: '02:30 ' + translation(18296),
      165: '02:45 ' + translation(18296),
      180: '03:00 ' + translation(18296),
      195: '03:15 ' + translation(18296),
      210: '03:30 ' + translation(18296),
      225: '03:45 ' + translation(18296),
      240: '04:00 ' + translation(18296),
      255: '04:15 ' + translation(18296),
      270: '04:30 ' + translation(18296),
      285: '04:45 ' + translation(18296),
      300: '05:00 ' + translation(18296),
      315: '05:15 ' + translation(18296),
      330: '05:30 ' + translation(18296),
      345: '05:45 ' + translation(18296),
      360: '06:00 ' + translation(18296),
      375: '06:15 ' + translation(18296),
      390: '06:30 ' + translation(18296),
      405: '06:45 ' + translation(18296),
      420: '07:00 ' + translation(18296),
      435: '07:15 ' + translation(18296),
      450: '07:30 ' + translation(18296),
      465: '07:45 ' + translation(18296),
      480: '08:00 ' + translation(18296),
      1440: '24 ' + translation('542') + ' (1 ' + translation('18105') + ')',
      2880: '48 ' + translation('542') + ' (2 ' + translation('503') + ')',
      4320: '72 ' + translation('542') + ' (3 ' + translation('503') + ')',
      5760: '96 ' + translation('542') + ' (4 ' + translation('503') + ')',
      7200: '120 ' + translation('542') + ' (5 ' + translation('503') + ')',
      8640: '144 ' + translation('542') + ' (6 ' + translation('503') + ')',
      10080: '168 ' + translation('542') + ' (7 ' + translation('503') + ')',
      11520: '192 ' + translation('542') + ' (8 ' + translation('503') + ')',
      12960: '216 ' + translation('542') + ' (9 ' + translation('503') + ')',
      14400: '240 ' + translation('542') + ' (10 ' + translation('503') + ')'
    }
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getProcessManagementInformation,
  saveProcessManagementInformation
})(ProcessManagement)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/ProcessManagement/index.js